import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { IconMenu3 } from '@tabler/icons-react';

const Header = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname || "Home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleHashChange = () => {
    setActiveLink(location.pathname);
  };

  useEffect(() => {
    handleHashChange();
  }, [location]);

  const handleToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  return (
    <>
      <div className="fixed-btn">
        <a href="https://wa.me/16476920900" target="_blank" className="whatsapp"><img src="../Images/whatsapp.png" alt="" /></a>
      </div>
      <Navbar expand="lg" id="header" ref={menuRef} expanded={isMenuOpen}>
        <Container fluid>
          <Link to="/home" className="navbar-brand"><img src="../Images/myfx-logo-new.png" alt="" /></Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle}><IconMenu3 size={40} stroke={2} /></Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto me-lg-5">
              <Link className={`nav-link ${activeLink === "/" || activeLink === "/home" || activeLink === "Home" ? 'active' : ''}`} to="/home">Home</Link>
              <NavDropdown title={
                <Link to="/services" className={`dd-link ${activeLink === "/services" || activeLink === "services" ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>Our Services</Link>} id="basic-nav-dropdown">
                <Link to="/effortlessglobalpayments" className={`dropdown-item ${activeLink === "effortlessglobalpayments" || activeLink === "/effortlessglobalpayments" ? 'active' : ''}`}>Effortless Global Payments</Link>
                <Link to="/applyforletterofcredit" className={`dropdown-item ${activeLink === "/applyforletterofcredit" || activeLink === "applyforletterofcredit" ? 'active' : ''}`}>Apply for Letter of Credit (LC)</Link>
                <Link to="/tuitionpaymentsforcanada" className={`dropdown-item ${activeLink === "/tuitionpaymentsforcanada" || activeLink === "tuitionpaymentsforcanada" ? 'active' : ''}`}>Tuition Payments for Canada</Link>
                <Link to="/realestateinvestmentpayments" className={`dropdown-item ${activeLink === "/realestateinvestmentpayments" || activeLink === "realestateinvestmentpayments"  ? 'active' : ''}`}>Real Estate Investment Payments</Link> 
              </NavDropdown>
              <Link className={`nav-link ${activeLink === "About" || activeLink === "/about" ? 'active' : '' }`} to="/about">About Us</Link>
              <Link className={`nav-link ${activeLink === "Contact" || activeLink === "/contact" ? 'active' : ''}`} to="/contact">Contact</Link>
              <Link className={`nav-link d-flex d-lg-none ${activeLink === "Login" || activeLink === "/login" ? 'active' : ''}`} to="/login">Login</Link>
              <Link className={`nav-link d-flex d-lg-none  ${activeLink === "Register" || activeLink === "/register" ? 'active' : ''}`} to="/register">Sign Up</Link>
            </Nav>
            <div className='btn-group d-lg-flex d-none'>
              <Link className={`link-btn yellow ${activeLink === "Login" || activeLink === "/login" ? 'active' : ''}`} to="/login">Login</Link>
              <Link className={`button yellow ${activeLink === "Register" || activeLink === "/register" ? 'active' : ''}`} to="/register">Sign Up</Link>
            </div>
          </Navbar.Collapse> 
        </Container>
      </Navbar>
    </>
  )
}

export default Header